<template>
  <v-card>
    <v-card-text>
      <v-form>
        <v-row>
          <v-col md6 class="pr-5">
            <v-text-field
              v-model="name"
              label="Name"
              :rules="nameRules"
              :readonly="disableNameEdit"
              required
            />
            <v-select
              :items="typeOptions"
              v-model="type"
              placeholder="Typ"
              hint="Typ"
            />

            <v-checkbox
              v-model="mandatory"
              label="Pflichfeld"
            />

            <v-text-field
              v-if="isNumericType"
              v-model="digitNumber"
              label="Digit number"
              type="number"
              min="1"
            />

            <v-text-field
              v-if="isOptionType"
              label="Add option"
              color="primary"
              v-model="newOption"
              @keypress.enter="addNewOption"
            >
              <template v-slot:append>
                <v-btn
                  depressed
                  tile
                  color="primary"
                  class="ma-0"
                  @click="addNewOption"
                >
                  Add
                  <v-icon right dark>mdi-plus</v-icon>
                </v-btn>
              </template>
            </v-text-field>

            <div v-if="isOptionType">
              <div
                v-for="item in valueOptions"
                :key="item"
                style="margin-bottom: 2px;"
              >
                <v-btn
                  depressed
                  tile
                  color="error"
                  class="ma-0"
                  @click="removeValueOption(item)"
                >
                  <v-icon right dark>mdi-delete</v-icon>
                </v-btn>

                <span class="ma-1 subtitle-1">{{item}}</span>
              </div>
            </div>
          </v-col>
          <v-col md-6 class="pa-2">
            <h4>Preview</h4>
            <br />
            <Metadata
              v-if="showPreview"
              :metadataDefinition="currentMetadataDefinition"
              :name="name"
              v-model="previewValue"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="default" text @click="doCancel">Abbrechen</v-btn>
      <v-btn v-if="canBeDeleted" color="error" class="white--text" @click="onDelete">
        <v-icon left dark>mdi-close</v-icon>
        Löschen
      </v-btn>
      <v-btn color="primary" @click="doConfirm" :disabled="!valid">Speichern</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import constants from '../../constants';
import Metadata from './Metadata';

export default {
  name: 'MetadataDefinition',
  props: {
    initialName: {
      type: String,
    },
    initialType: {
      type: String,
    },
    initialMandatory: {
      type: Boolean,
      default: false,
    },
    initialDigitNumber: {
      type: Number,
      default: 0,
    },
    initialValueOptions: {
      type: Array,
    },
  },
  components: {
    Metadata,
  },
  watch: {
    type(newValue) {
      if (newValue === constants.metadata.typeOption) {
        if (this.mandatory && this.valueOptiosn.length > 0) {
          this.previewValue = this.valueOptions[0];
        } else {
          this.previewValue = null;
        }
      } else {
        this.previewValue = null;
      }
    },
    mandatory(newValue) {
      if (newValue && this.type === constants.metadata.typeOption && this.valueOptions.length > 0) {
        this.previewValue = this.valueOptions[0];
      }
    }
  },
  mounted() {
  },
  computed: {
    valid() {
      return this.isValid();
    },
    showPreview() {
      return this.isValid();
    },
    currentMetadataDefinition() {
      let digitNumber = 0;
      if (this.type === constants.metadata.typeNumber &&
        this.digitNumber &&
        !isNaN(parseInt(this.digitNumber))) {
        digitNumber = parseInt(this.digitNumber);
      }
      return {
        name: this.name,
        type: this.type,
        mandatory: this.mandatory,
        digitNumber: digitNumber,
        valueOptions: this.type == constants.metadata.typeOption ? this.valueOptions : [],
      };
    },
    isNumericType() {
      return this.type === constants.metadata.typeNumber;
    },
    isOptionType() {
      return this.type === constants.metadata.typeOption;
    },
  },
  methods: {
    isValid() {
      return !!this.name;
    },
    removeValueOption(value) {
      const deleteIndex = this.valueOptions.findIndex( x => x === value);
      if (deleteIndex >= 0) {
        this.valueOptions.splice(deleteIndex, 1);
      }
    },
    addNewOption() {
      if (!this.newOption) {
        return;
      }

      if (!this.valueOptions.includes(this.newOption)) {
        this.valueOptions.push(this.newOption);
      }

      this.newOption = '';
    },
    onDelete() {
      this.$emit('delete', this.name);
    },
    doConfirm() {
      this.$emit('save', this.currentMetadataDefinition);

    },
    doCancel() {
      this.$emit('cancel');
    },
  },
  data() {
    return {
      canBeDeleted: !!this.initialName,
      disableNameEdit: !!this.initialName,
      name: this.initialName ? this.initialName : '',
      type: this.initialType ? this.initialType : constants.metadata.typeText,
      mandatory: this.initialMandatory,
      digitNumber: this.initialDigitNumber,
      valueOptions: this.initialValueOptions ? this.initialValueOptions : [],
      newOption: '',
      typeOptions: [{
        text: 'Alphanumerisch',
        value: constants.metadata.typeText,
        }, {
        text: 'Numerisch',
        value: constants.metadata.typeNumber,
        }, {
        text: 'Datum',
        value: constants.metadata.typeDate,
        }, {
        text: 'Options',
        value: constants.metadata.typeOption,
        },],
      nameRules: [
        v => !!v || 'Bitte geben Sie einen Titel ein',
      ],
      previewValue: '',
    };
  },
};
</script>
